<template>
  <div class="section-main__warp broadcast-audio-page">
    <ioc-table
      ref="dataTable"
      :data="dataList"
      :option="tableOption"
      :page="page"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @search-change="search"
      @row-save="saveForm"
      @row-cancel="saveCancel"
      @search-reset="search"
    >
      <!-- 顶部按钮 自定义 -->
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          class="iss-operation-button"
          v-auth="'/broadcast/audio:add'"
          @click="addAudio"
        >
          <!-- icon="el-icon-plus" -->
          新增音频
        </el-button>
        <el-button
          type="primary"
          size="small"
          class="iss-operation-button"
          v-auth="'/broadcast/audio:sync'"
          @click="syncAudio"
        >
          <!-- icon="el-icon-refresh" -->

          同步音频
        </el-button>
      </template>
      <template slot="fileCode" slot-scope="scope">
        <audio
          class="audio-comp-list"
          controls
          :src="XfileUrl + scope.row.fileCode"
        >
          您的浏览器不支持 audio 标签。
        </audio>
      </template>
      <template slot="fileCodeForm">
        <div class="flex-valign">
          <el-upload
            class="upload-demo"
            :class="{ hide: uploadStatus === 2 }"
            :show-file-list="false"
            drag
            name="files"
            accept="audio/mpeg, audio/mp4, audio/ac3, audio/basic, audio/3gpp, audio/ogg"
            action="common/file/batchFileload.json"
            :on-progress="uploading"
            :on-success="uploaded"
            :on-error="uploadError"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将音频文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
          <div class="flex-between upload-result" v-if="uploadStatus === 1">
            <span>{{ editForm.fileName }}</span>
            <span>{{ editForm.percent }}%</span>
          </div>
          <div class="flex-valign upload-result" v-if="uploadStatus === 2">
            <div class="flex-between mb10">
              <span>{{ editForm.fileName }}</span>
              <el-button
                type="text"
                size="small"
                class="iss-operation-button"
                icon="iconfont-lunan icon-lunan-shanchu"
                @click="deleteUpload"
              ></el-button>
            </div>
            <audio
              class="audio-comp"
              controls
              :src="$utils.Bus.imgPath(editForm.fileCode)"
            >
              您的浏览器不支持 audio 标签。
            </audio>
          </div>
        </div>
      </template>
      <template slot="menu" slot-scope="scope" width="100px">
        <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            v-auth="'/broadcast/audio:delete'"
            type="text"
            icon="iconfont icon-shanchu"
            @click="handleDelete(scope.row, scope.index)"
          >
          </el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <appPanel
      title="新增音频"
      :isExpand="showAddPanel"
      :modal="true"
      @cancel="handlePanelClose"
      :width="700"
    >
      <el-form ref="addForm" :model="editForm" :rules="addRule">
        <el-form-item label="音频名称" prop="name" label-width="120px">
          <el-input
            placeholder="请输入音频名称"
            v-model="editForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="请上传音频文件"
          prop="fileCode"
          label-width="120px"
        >
          <div class="flex-valign">
            <el-upload
              class="upload-demo"
              :class="{ hide: uploadStatus === 2 }"
              :show-file-list="false"
              drag
              name="files"
              accept="audio/mpeg, audio/mp4, audio/ac3, audio/basic, audio/3gpp, audio/ogg"
              action="common/file/batchFileload.json"
              :on-progress="uploading"
              :on-success="uploaded"
              :on-error="uploadError"
              :before-upload="beforeUpload"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将音频文件拖到此处，或<em>点击上传</em>
              </div>
            </el-upload>
            <div class="flex-between upload-result" v-if="uploadStatus === 1">
              <span>{{ editForm.fileName }}</span>
              <span>{{ editForm.percent }}%</span>
            </div>
            <div class="flex-valign upload-result" v-if="uploadStatus === 2">
              <div class="flex-between mb10">
                <span>{{ editForm.fileName }}</span>
                <el-button
                  type="text"
                  size="small"
                  class="iss-operation-button"
                  icon="iconfont-lunan icon-lunan-shanchu"
                  @click="deleteUpload"
                ></el-button>
              </div>
              <audio
                class="audio-comp"
                controls
                :src="$utils.Bus.imgPath(editForm.fileCode)"
              >
                您的浏览器不支持 audio 标签。
              </audio>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handlePanelClose">取消</el-button>
        <el-button @click="saveForm" type="primary">保存</el-button>
      </div>
    </appPanel>
  </div>
</template>

<script>
import appPanel from "@src/components/business/app-panel/index.vue";
import { Cache } from "$utils";
import { api } from "../api";
import utils from "@src/common/utils";
import tableOption from "../option/broadcastAudio.js";
export default {
  components: {
    appPanel,
  },
  data() {
    return {
      XfileUrl: Cache.get("SYS_FILEURL"),
      dataList: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },

      addRule: {
        name: [
          {
            required: true,
            message: "请输入音频名称",
            trigger: ["blur", "change"],
          },
        ],
        fileCode: [
          {
            required: true,
            message: "请上传音频文件",
            trigger: ["blur", "change"],
          },
        ],
      },
      tableOption: tableOption(),
      editForm: {},
      // 上传状态：0-未上传 1-上传中 2-上传成功 3-上传失败
      uploadStatus: 0,
      showAddPanel: false,
    };
  },
  mounted() {
    this.searchForm = {};
    this.getDataList();
  },
  methods: {
    deleteUpload() {
      this.uploadStatus = 0;
      this.editForm = {};
      this.$refs.dataTable.setForm("fileCode", "");
    },
    uploading(e) {
      this.uploadStatus = 1;
      this.editForm.percent = e.percent;
    },
    uploaded(e) {
      this.uploadStatus = 2;
      this.editForm.fileCode = e.returnObj[0].fileId;
      this.$refs.addForm.validateField("fileCode");
      this.$refs.dataTable.setForm("fileCode", this.editForm.fileCode);
    },
    beforeUpload(e) {
      this.uploadStatus = 0;
      this.editForm.fileName = e.name;
      this.editForm.fileSize = e.size;
    },
    uploadError(e) {
      this.uploadStatus = 3;
      this.$log.error("文件上传失败，错误信息为：", e);
      this.$message.error("文件上传失败");
    },
    syncAudio() {
      this.$fetch(api.syncAudio).then((res) => {
        if (res.success) {
          this.$message.success("同步音频文件成功");
          this.reloadData();
        } else {
          this.$message.error(res.msgContent || "同步音频文件失败");
        }
      });
    },
    addAudio() {
      this.showAddPanel = true;
      // this.$refs.dataTable.rowAdd();
    },
    handlePanelClose() {
      this.editForm = {};
      this.showAddPanel = false;
    },
    saveCancel() {
      this.$refs.dataTable.closeAdd();
    },
    saveForm(editForm, callback) {
      this.$refs["addForm"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          let params = {
            name: this.editForm.name,
            fileCode: this.editForm.fileCode,
          };
          this.$fetch(api.addAudio, params).then((res) => {
            if (res.success) {
              this.$message.success("新增音频文件成功");
              this.getDataList();
              this.handlePanelClose();
            } else {
              this.$message.error(res.msgContent || "新增音频文件失败");
            }
          });
        }
      });
      // let fileName = editForm.name;
      // let suffixIndex = this.editForm.fileCode.lastIndexOf(".");
      // let suffixName = this.editForm.fileCode.substr(suffixIndex);
      // if (fileName.split(suffixName)[1] !== "") {
      //   fileName += suffixName;
      // }
      // let params = {
      //   name: fileName,
      //   fileCode: this.editForm.fileCode,
      // };
      // this.$fetch(api.addAudio, params).then((res) => {
      //   if (res.success) {
      //     this.$message.success("新增音频文件成功");
      //     if (callback && typeof callback === "function") {
      //       callback();
      //     }
      //     this.getDataList();
      //   } else {
      //     this.$message.error(res.msgContent || "新增音频文件失败");
      //   }
      // });
      // this.$refs["dataTable"].$refs["form"].validate((valid) => {
      //   console.log(valid, "===valid");
      //   if (!valid) {
      //     return false;
      //   } else {
      //     let fileName = editForm.name;
      //     let suffixIndex = this.editForm.fileCode.lastIndexOf(".");
      //     let suffixName = this.editForm.fileCode.substr(suffixIndex);
      //     if (fileName.split(suffixName)[1] !== "") {
      //       fileName += suffixName;
      //     }
      //     let params = {
      //       name: fileName,
      //       fileCode: this.editForm.fileCode,
      //     };
      //     this.$fetch(api.addAudio, params).then((res) => {
      //       if (res.success) {
      //         this.$message.success("新增音频文件成功");
      //         if (callback && typeof callback === "function") {
      //           callback();
      //         }
      //         this.getDataList();
      //       } else {
      //         this.$message.error(res.msgContent || "新增音频文件失败");
      //       }
      //     });
      //   }
      // });
    },
    closeDialog() {
      this.deleteUpload();
    },
    search(searchForm = {}) {
      this.searchForm = searchForm;
      this.reloadData();
    },
    handleDelete(row) {
      this.$confirm("确定删除该音频文件吗？", "删除确认", {
        type: "warning",
      })
        .then((result) => {
          if (result) {
            this.$fetch(api.deleteAudio, {
              name: row.name,
            }).then((res) => {
              if (res.success) {
                this.$message.success("音频文件删除成功");
                this.getDataList();
              } else {
                this.$message.error(res.msgContent || "音频文件删除失败");
              }
            });
          }
        })
        .catch((e) => {
          this.$log.debug("用户取消删除音频文件");
        });
    },
    reloadData() {
      this.page.currentPage = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.reloadData();
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.getDataList();
    },
    getDataList() {
      const params = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        beginTime: this.searchForm.createTime && this.searchForm.createTime[0],
        endTime: this.searchForm.createTime && this.searchForm.createTime[1],
        ...this.searchForm,
      };
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.queryAudio, params).then((res) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (res.success) {
          this.dataList = (res.returnObj && res.returnObj.list) || [];
          this.page.total = (res.returnObj && res.returnObj.total) || 0;
        } else {
          this.$message.error(res.msgContent || "查询音频列表失败");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
:deep .el-upload {
  width: 100%;
}
:deep .el-upload-dragger {
  width: 100%;
}
.broadcast-audio-page {
  flex: 1;
  display: flex;
  flex-direction: column;

  .upload-demo {
    height: 190px;
    width: 100%;
    @include set_animation(height);
    overflow: hidden;

    &.hide {
      height: 0;
    }
  }

  .audio-comp-list {
    height: 25px !important;
    width: 300px !important;
    margin-bottom: -5px;
  }

  .upload-result {
    width: 360px;
    padding: 5px;
    @include set_theme_color(color, font-default-color);
    @include set_theme_color(background-color, input-default-bg-color);
    border-radius: 3px;

    .audio-comp {
      height: 30px;
      width: 350px;
    }
  }
}
</style>